import styles from "../styles.module.scss";

export type BriefPricingPocTag = {
  spocId: string;
  name: string;
};

type BriefPricingPocTagsProps = {
  tags: BriefPricingPocTag[];
  onClick: (value: string) => void;
};

export function BriefPricingPocTags({
  tags,
  onClick,
}: BriefPricingPocTagsProps) {
  if (!tags.length) {
    return null;
  }

  return (
    <div className={styles.briefPocSection}>
      <div className={styles.briefPocSectionTitle}>
        Pricing POCs on this brief
      </div>
      <div className={styles.briefPocTags}>
        {tags.map((tag) => (
          <span
            key={tag.spocId}
            className={styles.briefPocTag}
            style={{ cursor: "pointer" }}
            onClick={() => onClick(tag.name)}
          >
            {tag.name}
          </span>
        ))}
      </div>
    </div>
  );
}
